import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { clearUser } from 'redux/slices/auth';
import { store } from 'redux/store';

const getBaseURL = (): string => {
  const PROD_DOMAIN = 'global.devsymfony.io';
  const isProduction = window.location.hostname === PROD_DOMAIN;

  return isProduction
    ? process.env.REACT_APP_BASE_URL_PRODUCTION || ''
    : process.env.REACT_APP_BASE_URL || '';
};

const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 160000,
});

const errorHandler = (error: AxiosError) => {
  if (error?.response) {
    const status = error.response.status;
    if (status === 403 || status === 401) {
      localStorage.removeItem('token');
      store.dispatch(clearUser());
    }
  }
  console.error('error => ', error.message);
  return Promise.reject(error.response);
};

request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const access_token = localStorage.getItem('token');
    if (access_token && config.headers) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => errorHandler(error)
);

request.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error) => errorHandler(error)
);

export default request;